import { PropsWithChildren } from 'react';

import { STabPanel } from './style';

interface TabPanelProps {
  index: number;
  value: number;
}

const TabPanel = ({ value, index, children }: PropsWithChildren<TabPanelProps>) => {
  return (
    <STabPanel
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <div>{children}</div>}
    </STabPanel>
  );
};

export default TabPanel;
